import { NewTag, Tag } from '@griply/types';

import { DocumentSnapshot } from '../types/firestore';
import { stripUndefined } from '../utils/strip-undefined';
import { coerceFilterDocument } from './filter-document';
import { firebaseObjectTimestampToDate } from './firebase-timestamp-to-date';

export const tagConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): Tag => {
    // Whole-document conversion: the filter document's custom date ranges are nested timestamps too.
    const data = firebaseObjectTimestampToDate(snapshot.data()) as Record<
      string,
      unknown
    >;
    data.id = snapshot.id;
    // Stripped: tag writes spread the converted tag back into Firestore.
    return stripUndefined({
      ...data,
      name:
        typeof data.name === 'string'
          ? (data.name as string).trim()
          : data.name,
      filterDocument: coerceFilterDocument(data.filterDocument),
    }) as Tag;
  },
  toFirestore: (tag: Tag) => tag,
};

export const newTagConverter = (tag: NewTag) => ({
  ...tag,
  createdAt: new Date(),
});
